import { nanoid } from "nanoid";
import type { ServiceStandardFormValues } from "./ServiceStandardForm";

export const serviceStandardFormSamples: ServiceStandardFormValues[] = [
  {
    name: "ມາດຕະຖານບໍລິການຕ້ອນຮັບລູກຄ້າ",
    description: "ມາດຕະຖານການຕ້ອນຮັບລູກຄ້າຢ່າງເປັນມິດໃນຮ້ານ",
    serviceChannelId: "",
    departmentId: null,
    positionId: null,
    serviceStage: "before",
    status: "active",
    items: [
      {
        id: nanoid(),
        itemType: "do",
        content: "ຍິນດີຕ້ອນຮັບດ້ວຍສີໜ້າທີ່ມີຄວາມສຸກ",
        description: "ສະແດງຄວາມຍິນດີແລະຕ້ອນຮັບລູກຄ້າດ້ວຍສີໜ້າທີ່ເປັນມິດ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ຖາມວ່າລູກຄ້າຕ້ອງການຄວາມຊ່ວຍເຫຼືອຫຍັງ",
        description: "ສະແດງຄວາມສົນໃຈແລະຖາມລູກຄ້າເພື່ອເຂົ້າໃຈຄວາມຕ້ອງການ",
        orderIndex: 1,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ສະແດງຄວາມເຄົາລົບແລະມີມາລະຍາດ",
        description: "ປະພຶດຕົນຢ່າງເຄົາລົບແລະມີມາລະຍາດຕໍ່ລູກຄ້າ",
        orderIndex: 2,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນເບິ່ງທາງອື່ນໃນຂະນະທີ່ລູກຄ້າກໍາລັງພົວພັນ",
        description: "ໃຫ້ຄວາມສົນໃຈຢ່າງເຕັມທີ່ແກ່ລູກຄ້າ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນໃຊ້ໂທລະສັບຫຼືເຮັດວຽກອື່ນໃນຂະນະບໍລິການ",
        description: "ໃຫ້ຄວາມສົນໃຈຢ່າງເຕັມທີ່",
        orderIndex: 1,
      },
    ],
    examples: [
      {
        id: nanoid(),
        situation: "ລູກຄ້າເຂົ້າມາໃນຮ້ານ",
        example: "ຍິນດີຕ້ອນຮັບຄືນ! ມື້ນີ້ມີຫຍັງໃຫ້ຊ່ວຍແດ່ບໍ?",
        description: "ຕ້ອນຮັບດ້ວຍຄວາມສຸກແລະຖາມວ່າຕ້ອງການຄວາມຊ່ວຍເຫຼືອ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        situation: "ລູກຄ້າຖາມຂໍ້ມູນສິນຄ້າ",
        example: "ສິນຄ້ານີ້ມີຫຼາຍສີແລະຂະໜາດໃຫ້ເລືອກ. ທ່ານສົນໃຈສີໃດແດ່?",
        description: "ໃຫ້ຂໍ້ມູນທີ່ຊັດເຈນແລະຖາມຄວາມຕ້ອງການ",
        orderIndex: 1,
      },
    ],
    specialCases: [
      {
        id: nanoid(),
        title: "ລູກຄ້າບໍ່ພໍໃຈ",
        handling: "ຟັງຄຳຕິຊົມຢ່າງສະຫງົບ ແລະ ຊອກຫາວິທີແກ້ໄຂທີ່ດີທີ່ສຸດ",
        description: "ຖ້າລູກຄ້າບໍ່ພໍໃຈ ໃຫ້ຟັງຢ່າງສະຫງົບ ແລະ ຊອກຫາວິທີແກ້ໄຂ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        title: "ລູກຄ້າຕ້ອງການສິນຄ້າທີ່ບໍ່ມີໃນຮ້ານ",
        handling: "ບັນທຶກຄວາມຕ້ອງການ ແລະ ແນະນຳສິນຄ້າທີ່ຄ້າຍຄືກັນ",
        description: "ຖ້າບໍ່ມີສິນຄ້າທີ່ຕ້ອງການ ໃຫ້ບັນທຶກແລະແນະນຳທາງເລືອກອື່ນ",
        orderIndex: 1,
      },
    ],
  },
  {
    name: "ມາດຕະຖານບໍລິການລະຫວ່າງການບໍລິການ",
    description: "ມາດຕະຖານການບໍລິການລູກຄ້າໃນລະຫວ່າງການຊື້ຂາຍ",
    serviceChannelId: "",
    departmentId: null,
    positionId: null,
    serviceStage: "during",
    status: "active",
    items: [
      {
        id: nanoid(),
        itemType: "do",
        content: "ອະທິບາຍລາຍລະອຽດສິນຄ້າຢ່າງຊັດເຈນ",
        description: "ໃຫ້ຂໍ້ມູນທີ່ຊັດເຈນກ່ຽວກັບສິນຄ້າ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ຊ່ວຍລູກຄ້າເລືອກສິນຄ້າທີ່ເໝາະສົມ",
        description: "ຟັງຄວາມຕ້ອງການແລະແນະນຳສິນຄ້າທີ່ເໝາະສົມ",
        orderIndex: 1,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ຕອບຄຳຖາມຢ່າງມີຄວາມຮູ້",
        description: "ຕອບຄຳຖາມຂອງລູກຄ້າດ້ວຍຄວາມຮູ້ທີ່ຊັດເຈນ",
        orderIndex: 2,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນບັງຄັບລູກຄ້າໃຫ້ຊື້",
        description: "ໃຫ້ລູກຄ້າຕັດສິນໃຈເອງ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນໃຫ້ຂໍ້ມູນທີ່ບໍ່ຖືກຕ້ອງ",
        description: "ຖ້າບໍ່ແນ່ໃຈ ໃຫ້ຖາມຜູ້ຮັບຜິດຊອບຫຼືຄົ້ນຫາຂໍ້ມູນ",
        orderIndex: 1,
      },
    ],
    examples: [
      {
        id: nanoid(),
        situation: "ລູກຄ້າຖາມກ່ຽວກັບວັດສະດຸ",
        example: "ສິນຄ້ານີ້ເຮັດຈາກຝ້າຍ 100% ທີ່ມີຄຸນນະພາບສູງ ແລະ ສາມາດລ້າງໄດ້",
        description: "ໃຫ້ຂໍ້ມູນທີ່ຊັດເຈນກ່ຽວກັບວັດສະດຸ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        situation: "ລູກຄ້າບໍ່ແນ່ໃຈວ່າຄວນເລືອກສິນຄ້າໃດ",
        example: "ອີງຕາມຄວາມຕ້ອງການຂອງທ່ານ ຂ້ອຍແນະນຳສິນຄ້ານີ້ເພາະວ່າ...",
        description: "ຊ່ວຍລູກຄ້າເລືອກດ້ວຍການແນະນຳທີ່ມີເຫດຜົນ",
        orderIndex: 1,
      },
    ],
    specialCases: [
      {
        id: nanoid(),
        title: "ລູກຄ້າຕ້ອງການສິນຄ້າທີ່ບໍ່ມີສະຕ໋ອກ",
        handling: "ບັນທຶກຄວາມຕ້ອງການ ແລະ ແຈ້ງໃຫ້ຮູ້ວ່າຈະສາມາດສັ່ງຈອງໄດ້",
        description: "ຖ້າບໍ່ມີສະຕ໋ອກ ໃຫ້ບັນທຶກແລະແຈ້ງວ່າສາມາດສັ່ງຈອງໄດ້",
        orderIndex: 0,
      },
    ],
  },
  {
    name: "ມາດຕະຖານບໍລິການຫຼັງການຊື້",
    description: "ມາດຕະຖານການບໍລິການລູກຄ້າຫຼັງຈາກຊື້ສິນຄ້າ",
    serviceChannelId: "",
    departmentId: null,
    positionId: null,
    serviceStage: "after",
    status: "active",
    items: [
      {
        id: nanoid(),
        itemType: "do",
        content: "ຂອບໃຈລູກຄ້າສຳລັບການຊື້",
        description: "ສະແດງຄວາມຂອບໃຈຢ່າງຈິງໃຈ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ຖາມວ່າຕ້ອງການຄວາມຊ່ວຍເຫຼືອເພີ່ມເຕີມບໍ່",
        description: "ສະແດງຄວາມສົນໃຈຕໍ່ລູກຄ້າຫຼັງຈາກຊື້",
        orderIndex: 1,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ແນະນຳການໃຊ້ງານແລະການດູແລຮັກສາ",
        description: "ໃຫ້ຄຳແນະນຳກ່ຽວກັບການໃຊ້ງານສິນຄ້າ",
        orderIndex: 2,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນລືມຂອບໃຈລູກຄ້າ",
        description: "ສະເໝີຕ້ອງຂອບໃຈລູກຄ້າຫຼັງຈາກຊື້",
        orderIndex: 0,
      },
    ],
    examples: [
      {
        id: nanoid(),
        situation: "ຫຼັງຈາກລູກຄ້າຊື້ສິນຄ້າ",
        example: "ຂອບໃຈທີ່ເລືອກຊື້ກັບພວກເຮົາ! ຖ້າມີຄຳຖາມຫຼືຕ້ອງການຄວາມຊ່ວຍເຫຼືອ ກະລຸນາຕິດຕໍ່ມາໄດ້ສະເໝີ",
        description: "ຂອບໃຈແລະແຈ້ງວ່າສາມາດຕິດຕໍ່ໄດ້",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        situation: "ລູກຄ້າຖາມກ່ຽວກັບການດູແລຮັກສາ",
        example: "ສຳລັບການດູແລ ແນະນຳໃຫ້ລ້າງດ້ວຍມືໃນນ້ຳເຢັນ ແລະ ບໍ່ຄວນໃຊ້ສານຟອກ",
        description: "ໃຫ້ຄຳແນະນຳກ່ຽວກັບການດູແລຮັກສາ",
        orderIndex: 1,
      },
    ],
    specialCases: [
      {
        id: nanoid(),
        title: "ລູກຄ້າຕ້ອງການຄືນສິນຄ້າ",
        handling: "ກວດສອບໃບບິນ ແລະ ສະພາບສິນຄ້າ ແລ້ວດຳເນີນຕາມນະໂຍບາຍຄືນສິນຄ້າ",
        description: "ຖ້າລູກຄ້າຕ້ອງການຄືນສິນຄ້າ ໃຫ້ກວດສອບແລະດຳເນີນຕາມນະໂຍບາຍ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        title: "ລູກຄ້າບໍ່ພໍໃຈກັບສິນຄ້າ",
        handling: "ຟັງຄຳຕິຊົມ ຊອກຫາວິທີແກ້ໄຂ ແລະ ສາມາດແນະນຳສິນຄ້າອື່ນທີ່ເໝາະສົມ",
        description: "ຖ້າລູກຄ້າບໍ່ພໍໃຈ ໃຫ້ຟັງແລະຊອກຫາວິທີແກ້ໄຂ",
        orderIndex: 1,
      },
    ],
  },
  {
    name: "ມາດຕະຖານບໍລິການອອນລາຍ",
    description: "ມາດຕະຖານການບໍລິການລູກຄ້າຜ່ານຊ່ອງທາງອອນລາຍ",
    serviceChannelId: "",
    departmentId: null,
    positionId: null,
    serviceStage: "all",
    status: "active",
    items: [
      {
        id: nanoid(),
        itemType: "do",
        content: "ຕອບຂໍ້ຄວາມຢ່າງໄວ",
        description: "ຕອບຂໍ້ຄວາມຂອງລູກຄ້າພາຍໃນ 5 ນາທີ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ໃຫ້ຂໍ້ມູນທີ່ຊັດເຈນແລະຄົບຖ້ວນ",
        description: "ໃຫ້ຂໍ້ມູນທີ່ລູກຄ້າຕ້ອງການຢ່າງຊັດເຈນ",
        orderIndex: 1,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ໃຊ້ພາສາທີ່ເປັນມິດແລະເປັນທາງການ",
        description: "ສື່ສານດ້ວຍພາສາທີ່ເປັນມິດ",
        orderIndex: 2,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນໃຊ້ພາສາທີ່ບໍ່ເໝາະສົມ",
        description: "ຫຼີກເລີກການໃຊ້ພາສາທີ່ບໍ່ເໝາະສົມ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນປ່ອຍໃຫ້ລູກຄ້າລໍຖ້າດົນ",
        description: "ຕອບຂໍ້ຄວາມຢ່າງໄວເທົ່າທີ່ຈະເຮັດໄດ້",
        orderIndex: 1,
      },
    ],
    examples: [
      {
        id: nanoid(),
        situation: "ລູກຄ້າຖາມກ່ຽວກັບສິນຄ້າ",
        example: "ສະບາຍດີ! ສິນຄ້ານີ້ມີຫຼາຍສີແລະຂະໜາດໃຫ້ເລືອກ. ທ່ານສົນໃຈສີໃດແດ່?",
        description: "ຕອບດ້ວຍຄວາມສຸກແລະໃຫ້ຂໍ້ມູນທີ່ຊັດເຈນ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        situation: "ລູກຄ້າຖາມກ່ຽວກັບການຈັດສົ່ງ",
        example: "ສຳລັບການຈັດສົ່ງ ພວກເຮົາມີບໍລິການຈັດສົ່ງຟຣີສຳລັບຄຳສັ່ງທີ່ມີມູນຄ່າເກີນ 500,000 ກີບ",
        description: "ໃຫ້ຂໍ້ມູນກ່ຽວກັບການຈັດສົ່ງຢ່າງຊັດເຈນ",
        orderIndex: 1,
      },
    ],
    specialCases: [
      {
        id: nanoid(),
        title: "ລູກຄ້າບໍ່ພໍໃຈກັບການບໍລິການ",
        handling: "ຂໍອະໄພ ແລະ ຊອກຫາວິທີແກ້ໄຂທີ່ດີທີ່ສຸດ. ຖ້າຈຳເປັນ ໃຫ້ຕິດຕໍ່ຜູ້ຮັບຜິດຊອບ",
        description: "ຖ້າລູກຄ້າບໍ່ພໍໃຈ ໃຫ້ຂໍອະໄພແລະຊອກຫາວິທີແກ້ໄຂ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        title: "ລູກຄ້າຕ້ອງການສິນຄ້າທີ່ບໍ່ມີ",
        handling: "ບັນທຶກຄວາມຕ້ອງການ ແລະ ແຈ້ງໃຫ້ຮູ້ວ່າຈະສາມາດສັ່ງຈອງໄດ້ ຫຼື ແນະນຳສິນຄ້າທີ່ຄ້າຍຄືກັນ",
        description: "ຖ້າບໍ່ມີສິນຄ້າທີ່ຕ້ອງການ ໃຫ້ບັນທຶກແລະແນະນຳທາງເລືອກອື່ນ",
        orderIndex: 1,
      },
    ],
  },
  {
    name: "ມາດຕະຖານບໍລິການທົ່ວໄປ",
    description: "ມາດຕະຖານການບໍລິການລູກຄ້າທົ່ວໄປທຸກຊ່ອງທາງ",
    serviceChannelId: "",
    departmentId: null,
    positionId: null,
    serviceStage: "all",
    status: "draft",
    items: [
      {
        id: nanoid(),
        itemType: "do",
        content: "ສະແດງຄວາມເຄົາລົບແລະມີມາລະຍາດ",
        description: "ປະພຶດຕົນຢ່າງເຄົາລົບຕໍ່ລູກຄ້າທຸກຄົນ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ຟັງຄວາມຕ້ອງການຂອງລູກຄ້າຢ່າງລະອຽດ",
        description: "ໃຫ້ຄວາມສົນໃຈແລະຟັງລູກຄ້າຢ່າງລະອຽດ",
        orderIndex: 1,
      },
      {
        id: nanoid(),
        itemType: "do",
        content: "ໃຫ້ບໍລິການຢ່າງເປັນມືອາຊີບ",
        description: "ສະແດງຄວາມມືອາຊີບໃນການບໍລິການ",
        orderIndex: 2,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນປະພຶດຕົນຢ່າງບໍ່ເໝາະສົມ",
        description: "ຫຼີກເລີກການປະພຶດຕົນທີ່ບໍ່ເໝາະສົມ",
        orderIndex: 0,
      },
      {
        id: nanoid(),
        itemType: "dont",
        content: "ບໍ່ຄວນໃຫ້ຂໍ້ມູນທີ່ບໍ່ຖືກຕ້ອງ",
        description: "ຖ້າບໍ່ແນ່ໃຈ ໃຫ້ຖາມຜູ້ຮັບຜິດຊອບກ່ອນ",
        orderIndex: 1,
      },
    ],
    examples: [
      {
        id: nanoid(),
        situation: "ລູກຄ້າຖາມຂໍ້ມູນ",
        example: "ຂໍອະໄພ ຂ້ອຍຈະຊ່ວຍທ່ານທັນທີ. ທ່ານຕ້ອງການຂໍ້ມູນຫຍັງແດ່?",
        description: "ສະແດງຄວາມພ້ອມທີ່ຈະຊ່ວຍແລະຖາມຄວາມຕ້ອງການ",
        orderIndex: 0,
      },
    ],
    specialCases: [
      {
        id: nanoid(),
        title: "ລູກຄ້າບໍ່ພໍໃຈ",
        handling: "ຟັງຄຳຕິຊົມຢ່າງສະຫງົບ ຂໍອະໄພ ແລະ ຊອກຫາວິທີແກ້ໄຂທີ່ດີທີ່ສຸດ",
        description: "ຖ້າລູກຄ້າບໍ່ພໍໃຈ ໃຫ້ຟັງ ຂໍອະໄພ ແລະ ຊອກຫາວິທີແກ້ໄຂ",
        orderIndex: 0,
      },
    ],
  },
];

